(function () { if (!LN.Core) throw new Error("LN.Core missing"); })();

(function (Analytics, Helper, Config, Model) {
    'use strict';

    Analytics.paginaVirtualSignWall = function (page) {
        Analytics.pushData({
            'event': 'trackPageView',
            'pageName': page  // Pagina actual   
        })
    }

    Analytics.clickSSO = function (method) {
        Analytics.pushData({
            'event': 'trackClickSSO',
            'login-method': method  // Google, Facebook  
        })
    }

    Analytics.crearCuentaNativoClick = function () {
        Analytics.pushData({
            'event': 'trackClick',
            'eventLabel': 'Crear cuenta button'
        })
    }

    Analytics.crearCuentaNativoLink = function () {
        Analytics.pushData({
            'event': 'trackClick',
            'eventLabel': 'Crear cuenta link'
        })
    }

    Analytics.formError = function (label) {
        Analytics.pushData({
            'event': 'trackEvent',
            'eventCategory': 'autenticacion',
            'eventAction': 'error-form',
            'eventLabel': label,
        })
    }

    Analytics.error = function (error) {
        Analytics.pushData({
            'event': 'trackErrorPageV',
            'flow': 'autenticacion',
            'errorType': error,
            'errorPage': true
        })
    }

    Analytics.login = function (isNew, method, id) {
        Analytics.pushData({
            'event': 'trackLogin',
            'newUser': isNew,
            'loginMethod': method, // Facebook,Google,Mail
            'userID': id,
        })
    }

    Analytics.paginaVirtual = function (name) {
        Analytics.pushData({
            'event': 'trackPage',
            'pageName': name  // Pagina actual   
        })
    }

    Analytics.asociacionExitosa = function (type, started) {
        Analytics.pushData({
            'event': 'trackAccountLink',
            'accountType': type,  // Indicar� un string con el nombre del servicio que tiene el usuario, por ejemplo: Black       
            'started': started // Indicar� con un string la letra del flujo por el cual inici�. Por ejemplo: B
        })
    }


    Analytics.createAccount = function (name) {
        Analytics.pushData({
            'event': 'trackCreateAccount'
        })
    }

    /* CALL */
    Analytics.pushData = function (data) {
        (typeof dataLayer !== 'undefined') &&  dataLayer && dataLayer.push(data)   
    }

})(LN.Analytics, LN.Helper, LN.Config, LN.Model);


// WEBPACK FOOTER //
// ./Statics/scripts/login/core/analytics.js